import React, { Suspense } from 'react';

import { Box, GDSBoxProps, GDSStyleObject } from '@leagueplatform/genesis-core';
import { useScrollTopOnLocationChange } from '@leagueplatform/web-common';
import { ObservabilityErrorBoundary } from '@leagueplatform/observability';
import { LoadingIndicator } from '@leagueplatform/web-common-components';
import {
  ErrorState,
  ERROR_TYPES,
} from '@telus-alberta-health-web/shared-module';
import { HEADER_NAV_BAR_DEFAULT_HEIGHT } from '@telus-alberta-health-web/shared-module/src/components/header-nav/header-nav-bar.component';
import { AppNavBarComponent } from 'components/header-nav/header-nav.component';
import { QueryParamModal } from 'components/query-param-modal/query-param-modal.component';
import { AppFooter } from '../app-footer/app-footer.component';

type BasePageProps = GDSBoxProps<'div'> & {
  css?: GDSStyleObject;
  isPrivatePage?: boolean;
};

export const BasePage: React.FC<BasePageProps> = ({
  children,
  isPrivatePage = true,
  css,
  ...boxProps
}) => {
  useScrollTopOnLocationChange();

  const mainContentMinHeight = isPrivatePage
    ? `calc(100dvh - ${HEADER_NAV_BAR_DEFAULT_HEIGHT}px)`
    : '100dvh';

  return (
    <>
      {isPrivatePage && <AppNavBarComponent />}
      <Box
        as="main"
        id="main-content"
        css={{
          position: 'relative',
          flex: '1',
          minHeight: mainContentMinHeight,
          overflowX: 'hidden',
          ...css,
        }}
        {...boxProps}
      >
        <Suspense fallback={<LoadingIndicator />}>
          <ObservabilityErrorBoundary
            fallback={
              <ErrorState error={null} errorType={ERROR_TYPES.API_ERROR} />
            }
            errorContext={{
              context: {
                Context: { location: 'Base Page ErrorBoundary' },
              },
            }}
          >
            {isPrivatePage && <QueryParamModal />}
            {children}
          </ObservabilityErrorBoundary>
        </Suspense>
      </Box>
      <AppFooter />
    </>
  );
};
